import React, { Component } from 'react';
import HttpStatus from 'http-status-codes';
import { Link } from 'react-router-dom';
import { addOrder } from '../../api';
import Reports from '../management/Reports';

export default class OrderForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			order: '',
			submitting: false
		};
		this.addOrder = this.addOrder.bind(this);
	}

	addOrder(e) {
		e.preventDefault();
		const { order, submitting } = this.state;
		const codes = order.trim();
		if(codes && !submitting) {
			this.setState({ submitting: true });
			const dropship = e.target.value === 'Gebruik pakketdienst';
			Promise.all(codes.split(',').map(async code => {
				code = code.trim();
				if(!code) {
					return;
				}
				try {
					await addOrder(code, this.props.date, dropship);
				} catch(err) {
					if(err.response) {
						const { status, data } = err.response;
						if(status === HttpStatus.NOT_FOUND) {
							window.alert(`Order ${code} niet gevonden`);
						} else if(status === HttpStatus.CONFLICT) {
							window.alert(`Order ${code} bestaat al`);
						} else if(status === HttpStatus.PRECONDITION_FAILED) {
							if(data === 'EMPTY') {
								window.alert(`De items in order ${code} zijn niet aanwezig`);
							} else if(data === 'STATUS_NEW') {
								window.alert(`Order ${code} heeft status 10 NIEUW en kan niet worden toegevoegd`);
							} else {
								window.alert(data);
							}
						}
					}
					console.error('Failed to add order', err);
					return code;
				}
			})).then(remaining => {
				this.setState({ order: remaining.filter(Boolean).join(','), submitting: false });
			});
		}
	}

	render() {
		const { order, submitting } = this.state;
		return <header>
			<div className="row">
				<div className="col-md-6 col-xl-7">
					{this.props.person.role === 'CUSTOMER_SERVICE' && <form onSubmit={this.addOrder} className="form-inline">
						<input
							className="form-control"
							type="text"
							placeholder="Order Nummer"
							value={order}
							onChange={e => this.setState({ order: e.target.value })} />
						<input type="submit" value="Voeg toe" className="btn btn-primary" disabled={submitting} />
						<input type="submit" value="Gebruik pakketdienst" className="btn btn-info" onClick={this.addOrder} disabled={submitting} />
						<Link to="/import" className="btn btn-info">Import</Link>
					</form>}
				</div>
				<div className="col-md-6 col-xl-5 text-right">
					{this.props.person.role === 'CUSTOMER_SERVICE' && <p>
						<Link to={`/edi/${this.props.date}`} className="btn btn-primary">Dachser EDI & facturatie</Link>
						{' '}
						<Reports date={this.props.date} cs={true} />
					</p>}
				</div>
			</div>
		</header>;
	}
}
